// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app #verify-tree-grid .not-click {\n  pointer-events: none;\n}\n#app #verify-tree-grid .not-click button {\n    color: #fff;\n    background-color: #8cc8ff;\n    border-color: #acbcca;\n    cursor: not-allowed;\n}\n#app #verify-tree-grid button.not-click {\n  color: #fff;\n  background-color: #8cc8ff;\n  border-color: #8cc8ff;\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
